module.exports = __webpack_public_path__ + "img/classify-item6-active.5f5d1d0e.png";